import { Col, Row } from 'react-bootstrap';

function LogoImage({ logoImageAddress }: { logoImageAddress: string }) {
  if (!logoImageAddress) {
    return null;
  }

  return (
    <Row className="subscribe__header w-100 d-flex align-items-center m-0">
      <Col className="text-center">
        <img className="property__banner" alt="Banner" />
      </Col>
    </Row>
  );
}

export default LogoImage;
